export const caseStudyDiscovery = [
  {
    slug: 'vetnest',
    name: 'VetNest',
    service: 'Permission-aware clinic platform',
    image: 'homepage',
    summary:
      'I built an independent veterinary demo connecting a public website with content publishing, customer and pet records, and staff-managed appointments.',
    articles: [
      {
        slug: 'authentication-vs-authorization',
        title: 'How I think about authentication, RBAC and ABAC',
        description:
          'The access-control concepts behind permission-aware business applications.',
      },
      {
        slug: 'sessions-vs-jwts',
        title: 'Session design beyond the sign-in screen',
        description:
          'Where session state lives, how it expires and how it shapes an application.',
      },
    ],
  },
  {
    slug: 'indian-context',
    name: 'IndianContext',
    service: 'Editorial platform & CMS',
    image: 'homepage',
    summary:
      'I built a publication and editorial workspace for preparing articles, organising content and managing publishing through one connected platform.',
    articles: [
      {
        slug: 'server-side-request-flow-in-depth',
        title: 'What happens behind a server-rendered page',
        description:
          'Follow a request through the backend decisions that support a public interface.',
      },
      {
        slug: 'authentication-vs-authorization',
        title: 'Access control for publishing tools',
        description:
          'The distinction between identifying an editor and authorizing their actions.',
      },
    ],
  },
  {
    slug: 'my-clinic',
    name: 'My Clinic',
    service: 'Healthcare website development',
    image: 'homepage',
    summary:
      'I built a healthcare website connecting departments, doctor profiles and service details so visitors can understand their options and find a route to contact.',
    articles: [
      {
        slug: 'what-happens-when-you-press-enter',
        title: 'The engineering behind a useful website',
        description:
          'From a typed URL to a rendered interface: the full request and display journey.',
      },
      {
        slug: 'browser-rendering-in-depth',
        title: 'How the browser turns a page into an experience',
        description:
          'Layout, rendering and interaction fundamentals behind responsive interfaces.',
      },
    ],
  },
  {
    slug: 'packcraft-india',
    name: 'PackCraft India',
    service: 'Interactive 3D website',
    image: 'homepage',
    summary:
      'I built an interactive manufacturing website pairing 3D product storytelling with readable catalogue pages and a frontend quote-interface prototype.',
    articles: [
      {
        slug: 'browser-rendering-in-depth',
        title: 'Rendering and interaction on the web',
        description:
          'The browser fundamentals I consider when building expressive interfaces.',
      },
      {
        slug: 'production-debugging',
        title: 'Debugging beyond the visual surface',
        description:
          'A systematic approach to diagnosing behaviour in real web applications.',
      },
    ],
  },
] as const

export const workPageSeo = {
  title: 'Full-Stack Case Studies | Suriyaprakash Somu',
  description:
    'Case studies of production React and Node.js work: healthcare, manufacturing and publishing sites, customer portals, access control and staff workflows.',
  url: 'https://www.suriyaprakash.in/work',
}
